/**
 * API helper for ExecEdge Sales Funnel
 */
import axios from 'axios';
import apiBaseUrl from '../../config';

// Call backend directly
const api = axios.create({
  baseURL: `/api/execedge-funnel`,  // Direct backend call
  withCredentials: true,
});

// Token management
const TOKEN_KEY = 'execedge_funnel_token';

export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Last-route keys for pages behind ProtectedFunnelRoute — never persist without a session token,
// otherwise a direct URL hit redirects to /eedge but leaves a stale "resume" target.
export const EXECEDGE_LAST_ROUTE_TOKEN_REQUIRED = new Set([
	'/eedge/demo',
	'/eedge/program-plan',
	'/eedge/program-plan-test',
	'/eedge/payment',
]);

function isJwtExpired(token) {
	try {
		const payload = JSON.parse(atob(token.split('.')[1]));
		if (!payload.exp) return false;
		return Date.now() >= payload.exp * 1000;
	} catch {
		return true;
	}
}

/** JWT or anonymous funnel id; clears expired JWT from storage. */
export function getValidFunnelToken() {
	const token = getToken();
	if (!token) return null;
	const isJwt = token.split('.').length === 3;
	if (isJwt && isJwtExpired(token)) {
		clearToken();
		return null;
	}
	return token;
}

// Add token to requests
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

